import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import permissionValidations from './helpers';
import PermissionContext from './PermissionContext';
import PermissionsError from './PermissionError';
import { COMPONENT_TYPES, FALLBACK_TYPES } from './constants/permissions.constants';
var PermissionsConsumer = /*#__PURE__*/function (_PureComponent) {
  _inherits(PermissionsConsumer, _PureComponent);
  var _super = _createSuper(PermissionsConsumer);
  function PermissionsConsumer() {
    var _this;
    _classCallCheck(this, PermissionsConsumer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderFallBack", function () {
      var fallbackType = _this.props.fallbackType;
      if (fallbackType === FALLBACK_TYPES.ERROR) return /*#__PURE__*/React.createElement(PermissionsError, null);
      return null;
    });
    _defineProperty(_assertThisInitialized(_this), "getChildren", function () {
      var permissions = _this.context;
      var _this$props = _this.props,
        type = _this$props.type,
        validFor = _this$props.validFor,
        notValidFor = _this$props.notValidFor,
        validForAny = _this$props.validForAny,
        children = _this$props.children,
        getRoleBasedProps = _this$props.getRoleBasedProps;
      var validation = permissionValidations.validatePermissions(permissions, {
        validFor: validFor,
        notValidFor: notValidFor,
        validForAny: validForAny
      });
      switch (type) {
        // TODO: Change to simple if and return if not adding more COMPONENT_TYPES options.
        case COMPONENT_TYPES.PASS_THROUGH:
          // will not work with React.Fragment as children
          return React.Children.map(children, function (child) {
            return /*#__PURE__*/React.cloneElement(child, getRoleBasedProps(validation));
          });
        default:
          if (validation) {
            return children;
          }
          return _this.renderFallBack();
      }
    });
    return _this;
  }
  _createClass(PermissionsConsumer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        containerClassName = _this$props2.containerClassName,
        shouldReturnNull = _this$props2.shouldReturnNull;
      var children = this.getChildren();
      if (shouldReturnNull && !children) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: containerClassName
      }, children);
    }
  }]);
  return PermissionsConsumer;
}(PureComponent);
_defineProperty(PermissionsConsumer, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  type: PropTypes.string,
  validFor: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  notValidFor: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  validForAny: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  getRoleBasedProps: PropTypes.func,
  containerClassName: PropTypes.string,
  shouldReturnNull: PropTypes.bool,
  fallbackType: PropTypes.string
});
_defineProperty(PermissionsConsumer, "defaultProps", {
  validFor: EMPTY_STRING,
  notValidFor: EMPTY_STRING,
  validForAny: EMPTY_STRING,
  type: 'hide',
  getRoleBasedProps: function getRoleBasedProps(n) {
    return {
      validation: n
    };
  },
  containerClassName: '',
  shouldReturnNull: false,
  fallbackType: FALLBACK_TYPES.NONE
});
PermissionsConsumer.contextType = PermissionContext;
export default PermissionsConsumer;